import {ImprovementsMapMask} from './ImprovementsMapService';

export const IMPROVEMENTS_MAP_MAX_ROWS = 3;
export const IMPROVEMENTS_MAP_PADDING = 80;
export const IMPROVEMENTS_MAP_CARD_CLASS_NAME = 'improvement-card';
export const IMPROVEMENTS_MAP_ICON_ID_PREFIX = 'improvements-map-icon-';

export const IMPROVEMENTS_MAP_X_GAP_MIN = 180;
export const IMPROVEMENTS_MAP_X_GAP_MAX = 200;
export const IMPROVEMENTS_MAP_Y_GAP_MIN = 220;
export const IMPROVEMENTS_MAP_Y_GAP_MAX = 300;

export const IMPROVEMENTS_MAP_MAX_CLIENT_WIDTH = 800;
export const IMPROVEMENTS_MAP_MAX_CLIENT_HEIGHT = 1080;

export const IMPROVEMENTS_MAP_LINE_WIDTH = 1.5;

// ограничение расположения сверху, которое не дает выезжать карточкам
// значение подобранное чтобы не усложнять логику
export const IMPROVEMENTS_MAP_TOP_EDGE = 50;

export const IMPROVEMENTS_MAP_RESIZE_DEBOUNCE = 500;

export const IMPROVEMENTS_MAP_MASK: ImprovementsMapMask = [
  [1, 0, 1, 0, 0, 0],
  [1, 1, 1, 1, 0, 1],
  [1, 1, 0, 0, 1, 0],
];
